import { render, staticRenderFns } from "./correlation.vue?vue&type=template&id=5c02e6c3&scoped=true"
import script from "./correlation.vue?vue&type=script&lang=js"
export * from "./correlation.vue?vue&type=script&lang=js"
import style0 from "./correlation.vue?vue&type=style&index=0&id=5c02e6c3&prod&lang=css"
import style1 from "./correlation.vue?vue&type=style&index=1&id=5c02e6c3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c02e6c3",
  null
  
)

export default component.exports